module.exports = __webpack_public_path__ + "assets/Pi.3a9bc7dd99d9b87c7945233b18434c2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs2x/Pi.png
// module id = 843
// module chunks = 0